module.exports = __webpack_public_path__ + "static/media/cover-login-access-2.100a2cb9.jpg";